import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Toast, NavBar } from 'antd-mobile';
import { LeftOutline } from 'antd-mobile-icons';
import request from 'src/utils/request';
import './style/registerStyle.scss';
import Logo from 'src/assets/images/LOGO.png';

export default function Register() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [countdown, setCountdown] = useState(0);

    // 发送验证码
    const handleSendCode = async () => {
        const phone = form.getFieldValue('phone');

        if (!phone || !/^1[3-9]\d{9}$/.test(phone)) {
            Toast.show('请先输入有效的手机号');
            return;
        }

        try {
            const response = await request.post('/public/User/Sms', { phone });
            if (response && response.ok) {
                Toast.show('验证码已发送');
                setCountdown(60);
                const timer = setInterval(() => {
                    setCountdown(prev => {
                        if (prev <= 1) {
                            clearInterval(timer);
                            return 0;
                        }
                        return prev - 1;
                    });
                }, 1000);
            } else {
                Toast.show(response?.msg || '发送失败');
            }
        } catch (error) {
            Toast.show('发送失败，请重试');
        }
    };

    // 注册
    const handleRegister = async (values) => {
        setLoading(true);

        try {
            const response = await request.post('/public/User/Register', {
                phone: values.phone,
                code: values.code,
                passWord: values.passWord,
                userName: values.userName || values.phone
            });

            if (response && response.ok) {
                Toast.show({
                    icon: 'success',
                    content: '注册成功',
                    duration: 1500,
                });

                // 延迟跳转到登录页
                setTimeout(() => {
                    navigate('/login');
                }, 1500);
            } else {
                Toast.show({
                    icon: 'fail',
                    content: response?.msg || '注册失败',
                    duration: 1500,
                });
            }
        } catch (error) {
            console.error('注册失败:', error);
            Toast.show({
                icon: 'fail',
                content: '注册失败，请重试',
                duration: 1500,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='register-container'>
            <NavBar
                backArrow={<LeftOutline />}
                onBack={() => navigate(-1)}
                className="register-navbar"
            >
                <span style={{ color: 'white' }}>注册账号</span>
            </NavBar>

            <div className="register-content">
                <div className="register-logo-section">
                    <div className="logo-img">
                        <img src={Logo} alt="Logo" onError={(e) => {
                            e.target.style.display = 'none';
                        }} />
                    </div>
                    <div className="app-name">猪场交易平台</div>
                    <div className="app-slogan">创建您的账号，开始交易</div>
                </div>

                <div className="register-form-card">
                    <Form
                        form={form}
                        onFinish={handleRegister}
                        layout='vertical'
                        footer={
                            <div className="register-btn-group">
                                <Button
                                    block
                                    type='submit'
                                    color='primary'
                                    size='large'
                                    loading={loading}
                                    disabled={loading}
                                    className="register-btn"
                                >
                                    {loading ? '注册中...' : '立即注册'}
                                </Button>
                                <div className="login-link-wrapper">
                                    已有账号？
                                    <span className="login-link" onClick={() => navigate('/login')}>
                                        去登录
                                    </span>
                                </div>
                            </div>
                        }
                    >
                        <Form.Item
                            name='phone'
                            label='手机号'
                            rules={[
                                { required: true, message: '请输入手机号' },
                                { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号' }
                            ]}
                        >
                            <Input
                                placeholder='请输入手机号'
                                clearable
                                type='tel'
                                maxLength={11}
                            />
                        </Form.Item>

                        <Form.Item
                            name='code'
                            label='验证码'
                            rules={[{ required: true, message: '请输入验证码' }]}
                        >
                            <div className="code-input-wrapper">
                                <Input
                                    placeholder='请输入验证码'
                                    clearable
                                    maxLength={6}
                                />
                                <Button
                                    className="code-btn"
                                    disabled={countdown > 0}
                                    onClick={handleSendCode}
                                >
                                    {countdown > 0 ? `${countdown}秒` : '获取验证码'}
                                </Button>
                            </div>
                        </Form.Item>

                        <Form.Item
                            name='userName'
                            label='账号（可选）'
                        >
                            <Input
                                placeholder='不填写则使用手机号作为账号'
                                clearable
                            />
                        </Form.Item>

                        <Form.Item
                            name='passWord'
                            label='密码'
                            rules={[
                                { required: true, message: '请输入密码' },
                                { min: 6, message: '密码至少6位' }
                            ]}
                        >
                            <Input
                                type='password'
                                placeholder='请输入密码（至少6位）'
                                clearable
                            />
                        </Form.Item>

                        <Form.Item
                            name='confirmPassword'
                            label='确认密码'
                            rules={[
                                { required: true, message: '请确认密码' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('passWord') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('两次输入的密码不一致'));
                                    },
                                }),
                            ]}
                        >
                            <Input
                                type='password'
                                placeholder='请再次输入密码'
                                clearable
                            />
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
}
